import { useDispatch } from 'react-redux'
import { Drawer } from 'antd'
import React from 'react'
import { userActions } from '../../../../../store/slices/user.slice'
import EditUserForm from './EditUserForm'

const EditUserDrawer = () => {
    const dispatch = useDispatch()

    const handleClose = () => dispatch(userActions.setEditingUserId(null))

    return (
        <Drawer title='Edit User' autoFocus onClose={handleClose} open width={560} destroyOnClose mask={null}>
            <EditUserForm onSuccess={handleClose} />
        </Drawer>
    )
}

export default EditUserDrawer
